import { render } from "./NotificationInfo.vue?vue&type=template&id=440a5ed6"
import script from "./NotificationInfo.vue?vue&type=script&lang=js"
export * from "./NotificationInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__